import { parseJSON } from './parsers';
export const getMetaValueRaw = (x) => { var _a; return (_a = document.querySelector(`head meta[name="${x}"]`)) === null || _a === void 0 ? void 0 : _a.getAttribute('content'); };
export const getMetaValue = (x) => parseJSON(getMetaValueRaw(x));
export const getMetaValueOptional = (x) => ((x) => x ? parseJSON(x) : undefined)(getMetaValueRaw(x));
